import { lazy } from 'react';
import { getAuthenticatorFromAuth } from 'utils/login-utils';
import { setSessionStorageItem } from 'utils/storage-utils';

import {
  getBankAccountPropsFromKcContext,
  getOtpPropsFromKcContext,
  getRecreatePasswordPropsFromKcContext,
  getScratchPropsFromKcContext,
  getSecureAnswersPropsFromKcContext,
} from 'app/props/kc-context-to-props';

import {
  getAndPresaveScratchProps,
} from 'app/props/presaved-props';

import { PRESAVE_PARAMS } from 'consts/flow-constants';
import {
  CUSTOMER_AUTHENTICATORS,
  OTP_AUTHENTICATORS,
  RECOVER_PASSWORD_AUTHENTICATORS,
  SCRATCH_AUTHENTICATORS,
} from 'consts/authenticators-constants';

import { NOT_POSSIBLE_OPERATION_TYPES } from 'web-ui-kit/dist/uni-credit-not-possible';
import { KcResetPasswordContext } from 'types';

const RecoverPasswordStep1Page = lazy(() => import('pages/recover-password-step-1-page'));
const RecoverPasswordStep2OtpPage = lazy(() => import('pages/recover-password-step-2-otp-page'));
const RecoverPasswordStep2ScratchPage = lazy(() => import('pages/recover-password-step-2-scratch-page'));
const RecoverPasswordStep3Page = lazy(() => import('pages/recover-password-step-3-page'));
const RecoverPasswordStep4Page = lazy(() => import('pages/recover-password-step-4-page'));
const NotPossiblePage = lazy(() => import('pages/not-possible-page'));

export default function AppResetPasswordFlow(kcContext: KcResetPasswordContext) {
  const authenticator = getAuthenticatorFromAuth(kcContext.auth);

  switch (authenticator) {
    case CUSTOMER_AUTHENTICATORS.BANK_ACCOUNT:
      resetRecoverPasswordFlow();

      return <RecoverPasswordStep1Page
        {...getBankAccountPropsFromKcContext(kcContext)}
      />;

    case OTP_AUTHENTICATORS.CONFIRM_SMS:
      return <RecoverPasswordStep2OtpPage
        {...getOtpPropsFromKcContext(kcContext)}
      />;

    case SCRATCH_AUTHENTICATORS.CONFIRM_SCRATCH:
      return <ScratchCardPageDependOnKeysCount
        {...kcContext}
      />;

    case RECOVER_PASSWORD_AUTHENTICATORS.SECURE_ANSWERS:
      return <RecoverPasswordStep3Page
        {...getSecureAnswersPropsFromKcContext(kcContext)}
      />;

    case RECOVER_PASSWORD_AUTHENTICATORS.NEW_PASSWORD:
      return <RecoverPasswordStep4Page
        {...getRecreatePasswordPropsFromKcContext(kcContext)}
      />;

    default:
      throw new Error(`RecoverPassword authenticator [${authenticator}] not found.`);
  }
}

function ScratchCardPageDependOnKeysCount(kcContext: KcResetPasswordContext) {
  const availableKeysCount = parseInt(kcContext.tan_key_count);

  if (availableKeysCount <= 0) {
    return <NotPossiblePage
      reason={NOT_POSSIBLE_OPERATION_TYPES.OPERATION}
    />;
  }

  return <RecoverPasswordStep2ScratchPage
    {...getScratchPropsFromKcContext(kcContext)}
    {...getAndPresaveScratchProps(kcContext)}
  />;
}

export function resetRecoverPasswordFlow() {
  setSessionStorageItem(PRESAVE_PARAMS.SECOND_ATTEMPT, '');
}
